import { render, staticRenderFns } from "./screen_config_settings_modal.vue?vue&type=template&id=698699e4&scoped=true"
import script from "./screen_config_settings_modal.vue?vue&type=script&lang=js"
export * from "./screen_config_settings_modal.vue?vue&type=script&lang=js"
import style0 from "./screen_config_settings_modal.vue?vue&type=style&index=0&id=698699e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698699e4",
  null
  
)

export default component.exports